import styled from 'styled-components';
import { unit } from 'modules/v2/foundation/spacing';
export const Container = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${unit('sm')};
  padding: ${unit('sm')};
`;
export const ButtonText = styled.span `
  white-space: nowrap;
`;
